/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

const progressSchema = z.object({
  level: z.number(),
  nextReviewAt: z.number(),
  passed: z.number(),
  failed: z.number(),
  skipped: z.number(),
  totalTimeSpent: z.number(),
  lastReviewedAt: z.number(),
  firstSeenAt: z.number(),
});

const collectionSummarySchema = z.object({
  id: z.number(),
  title: z.string(),
  slug: z.string(),
  posterUrl: z.string().nullable(),
  parentTitle: z.string().nullable(),
  hasClip: z.boolean(),
});

const recentReviewSchema = z.object({
  id: z.string(),
  answer: z.string(),
  level: z.number(),
  timeSpent: z.number(),
  timestamp: z.number(),
});

export const challengeStatsSchema = z.object({
  progress: progressSchema.nullable(),
  successRate: z.number().nullable(),
  avgTimePerReview: z.number().nullable(),
  totalReviews: z.number(),
  publishedClipCount: z.number(),
  collectionCount: z.number(),
  collections: z.array(collectionSummarySchema),
  recentReviews: z.array(recentReviewSchema),
});

export type IChallengeStats = z.infer<typeof challengeStatsSchema>;
